import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Validate from '../lib/validate';
import Settings from '../lib/settings';
import {Editor} from 'react-draft-wysiwyg';
import {EditorState, convertToRaw, ContentState} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import htmlToDraft from 'html-to-draftjs';
import Helpers from '../lib/helpers';
import * as Actions from '../actions';
import {connect} from 'react-redux';

class AddProduct extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: '',
      description: '',
      discount: '',
      price: '',
      images: [],
      categories: [],
      sended: false,
      formMessage: [],
      noValues: 1,
      parameterName: '',
      parameterValues: [""],
      parameters: [],
      editorState: EditorState.createEmpty(),
      isUpdating: false,
      categoriesList: [],
      categoriesState: [],
      canScroll: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleArrayChange = this.handleArrayChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addParameterValueForm = this.addParameterValueForm.bind(this);
    this.handleSubmitParameter = this.handleSubmitParameter.bind(this);
    this.removeParameter = this.removeParameter.bind(this);
    this.handleImage = this.handleImage.bind(this);
    //this.addFormMessage = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (typeof this.props.match.params.slug !== "undefined") {
      fetch('/api/product/' + this.props.match.params.slug, Settings.fetchParams('GET')).then(res => res.json()).then(json => {
        if (json === null) {
          this.setState({isUpdating: false});
        } else {
          this.setState(json);
          this.setState({isUpdating: true});
          const contentBlock = htmlToDraft(json.description);
          if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            const editorState = EditorState.createWithContent(contentState);
            this.setState({editorState});
          }
        }
      });
    }

    fetch('/api/categories/', Settings.fetchParams('GET')).then(res => res.json()).then(json => {

      this.setState({categoriesList: json});

    });
    window.scrollTo(0, this.props.menuPosition);
  }

  componentDidUpdate() {
  //  window.scrollTo(0, this.props.menuPosition);
  }

  componentWillReceiveProps(newProps) {
    window.scrollTo(0, this.props.menuPosition);
    if (typeof newProps.match.params.slug === "undefined") {

      this.setState({
        name: '',
        description: '',
        discount: '',
        price: '',
        images: [],
        categories: [],
        sended: false,
        formMessage: [],
        noValues: 1,
        parameterName: '',
        parameterValues: [""],
        parameters: [],
        editorState: EditorState.createEmpty(),
        isUpdating: false,
        categoriesList: [],
        categoriesState: []
      });

      fetch('/api/categories/', Settings.fetchParams('GET')).then(res => res.json()).then(json => {

        this.setState({categoriesList: json});

      });
    }


  }


  onEditorStateChange: Function = (editorState) => {
    this.setState({editorState});
    //console.log(convertToRaw(this.state.editorState.getCurrentContent()));
  };

  addParameterValueForm() {
    this.setState(prevState => ({
      parameterValues: [
        ...prevState.parameterValues,
        ""
      ]
    }));
    //ReactDOM.findDOMNode(this.refs[name]).classList.add(Settings.wrongInput);
  }

  addWrongInputClass(name) {
    ReactDOM.findDOMNode(this.refs[name]).classList.add(Settings.wrongInput);
  }

  addFormMessage(message) {

    this.setState(prevState => ({
      formMessage: [
        ...prevState.formMessage,
        message
      ],
      canScroll: true
    }));
  }

  handleChange(event) {

    this.setState({
      [event.target.name]: event.target.value
    });
    ReactDOM.findDOMNode(this.refs[event.target.name]).classList.remove(Settings.wrongInput);
  }

  handleCategoryChange(event) {

    let items = this.state.categories;
    if (event.target.checked && !items.includes(event.target.value)) {

      items.push(event.target.value);
      this.setState({categories: items});

    } else if (!event.target.checked && items.includes(event.target.value)) {

      let index = items.indexOf(event.target.value);
      items.splice(index, 1);
      this.setState({categories: items});

    }

    ReactDOM.findDOMNode(this.refs.categories).classList.remove(Settings.wrongInput);

  }

  handleArrayChange(event) {

    const items = this.state.parameterValues;
    items[event.target.name] = event.target.value;

    this.setState({parameterValues: items});
  }

  removeParameter(i) {

    let items = this.state.parameters;
    items.splice(i, 1);
    this.setState({parameters: items});

  }

  removeParameterValue(i, y) {

    let items = this.state.parameters;
    items[i].values.splice(y, 1);
    this.setState({parameters: items});

  }

  uploadImages(callback) {

    let data = new FormData();
    data.append('file', ReactDOM.findDOMNode(this.refs.mainImage).files[0]);
    for (let i = 0; i < ReactDOM.findDOMNode(this.refs.images).files.length; i++) {
      data.append('file', ReactDOM.findDOMNode(this.refs.images).files[i]);
    }

    fetch('/api/products/uploadimg', {
      mode: 'cors',
      credentials: "include",
      headers: {
        'Access-Control-Allow-Origin': '*'
      },
      method: 'POST',
      body: data
    }).then(res => {
      if (res.ok) {
        res.json().then(json => {

          if (!json.error) {
            if (typeof json.imgNames !== "undefined") {
              callback(json.imgNames);
              //alert(json.imgNames[0]);
            } else {
              alert("Chyba při nahrávání obrázku!");
            }

          } else {
            alert("Chyba při nahrávání obrázku! Server neodpovídá");
          }
        })
      } else {
        return {error: true}
      }
    }).catch((err) => {
      console.log(err);
    });

  }

  handleSubmit(event) {

    event.preventDefault();
    let errorCheck = true;

    let descriptionHtml = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()));

    this.setState({formMessage: []});

    if (!this.state.isUpdating) {
      if (typeof ReactDOM.findDOMNode(this.refs.mainImage).files[0] === "undefined") {
        this.addFormMessage("Pro přidání produktu prosím vložte obrázek.");
        errorCheck = false;
        this.addWrongInputClass("mainImage");
      }
    }

    if (!Validate.product(this.state.name, "name")) {
      this.addFormMessage("Pro přidání produktu prosím vyplňte název produktu.");
      errorCheck = false;
      this.addWrongInputClass("name");
    }

    if (!Validate.product(descriptionHtml, "description")) {
      this.addFormMessage("Pro přidání produktu prosím vyplňte popis produktu.");
      errorCheck = false;
      this.addWrongInputClass("description");
    }

    if (!Validate.product(this.state.price.replace(",", "."), "price")) {
      this.addFormMessage("Pro přidání produktu prosím vyplňte cenu produktu. (musí být číslo)");
      errorCheck = false;
      this.addWrongInputClass("price");
    }

    if (!Validate.product(this.state.discount.replace(",", "."), "discount") && this.state.discount !== "") {
      this.addFormMessage("Slevu vyplňte v procentech bez znaku %. (1-100)");
      errorCheck = false;
      this.addWrongInputClass("discount");
    }

    if (this.state.categories.length < 1) {
      this.addFormMessage("Přidejte zboží alespoň do jedné kategorie");
      errorCheck = false;
      this.addWrongInputClass("categories");
    }

    if (errorCheck) {
      this.props.dispatch(Actions.loader(true));

      const uploadProduct = (images) => {
        let product = {
          name: this.state.name,
          description: descriptionHtml,
          price: this.state.price,
          images: images,
          categories: this.state.categories
        };

        if (this.state.discount !== "") {
          product.discount = this.state.discount;
        }

        if(this.state.isUpdating) {
          product.slug = this.state.slug;
          product.active = this.state.active
        }

        if (this.state.parameters.length > 0 || this.state.isUpdating) {
          product.parameters = this.state.parameters;
        }

        if (Validate.product(product, "for_insert")) {

          var sucessText;
          if(this.state.isUpdating) {
            sucessText = "Změny uloženy!";
          } else {
            sucessText = "Produkt přidán!";
          }

          var fetchAdd;
          if(this.state.isUpdating) {
            fetchAdd = '/api/products/' + this.state.slug;
          } else {
            fetchAdd = '/api/products';
          }


          fetch(fetchAdd, Settings.fetchParams('POST', product)).then(res => {
            this.props.dispatch(Actions.loader(false));
            if (res.ok) {
              res.json().then(json => {
                if (!json.error) {
                  window.scrollTo(0, this.props.menuPosition);
                  ReactDOM.findDOMNode(this.refs.addProduct).innerHTML = '<h2 class="addSuccess">' + sucessText + '</h2>';
                } else {
                  console.log("Error");
                }
              })
            } else {
              alert("Error");
            }
          });

        } else {
          alert("Vyplňte korektně formulář..");
        }

      }

      if (this.state.isUpdating) {
        uploadProduct(this.state.images);
      } else {
        this.uploadImages(uploadProduct);
      }

    }

  }

  handleImage(event) {
    /*
    console.log(event.target);

    var data = this.state.imagesForm;
    data.append('file[]', event.target.files[0]);

    this.setState({imagesForm: data});


    fetch('/api/products/uploadimg', {
  method: 'POST',
  body: data
}).then(res => {
  if (res.ok) {
    return res.json()
  } else {
    alert("Error");
  }
}).then(json => {
  if (!json.error) {
    if (typeof json.imgName !== "undefined") {
      this.setState({image: json.imgName});
    } else {
      alert("Chyba při nahrávání!");
    }

  } else {
    console.log("Error");
  }
});; */



Array.from(event.target.files).forEach((img) => {
  if(img.size > 20971520) {
    alert("Velikost obrázku může být maximálně 20MB");
    event.target.value = "";
    return;
  }
});


  }

  handleSubmitParameter(event) {
    event.preventDefault();

    if (this.state.parameterName === "") {
      alert("Vyplňte název parametru.")
    } else {

      let trimmedValues = [];

      this.state.parameterValues.forEach((item) => {

        if (item !== "") {
          trimmedValues.push(item);
        }

      });

      if (trimmedValues.length > 0) {
        let newParameter = {
          name: this.state.parameterName,
          values: trimmedValues
        }

        this.setState(prevState => ({
          parameters: [
            ...prevState.parameters,
            newParameter
          ],
          parameterName: '',
          parameterValues: [""]
        }));
      } else {
        alert("Vyplňte hodnoty parametru.")
      }

    }

  }

  render() {

    if(this.state.formMessage.length > 0 && this.state.canScroll) {
      window.scrollTo(0, this.props.menuPosition);
      this.setState({
        canScroll: false
      });
    }

    const formErrorMessages = this.state.formMessage.map((item, index) => <p key={index}>{item}</p>);
    const parametersList = this.state.parameters.map((item, index) => <div key={index} className="parameters">
      <h3>
        <i className="fas fa-times removeParam" onClick={() => {
            this.removeParameter(index)
          }}></i>{item.name}:</h3>
      {
        item.values.map((item2, index2) => <p key={index2}>
          <i className="fas fa-times removeParam" onClick={() => {
              this.removeParameterValue(index, index2)
            }}></i>{item2}</p>)
      }
    </div>);
    //const parameterValues = (i) => ;
    const parameterValuess = this.state.parameterValues.map((item, index) => <div key={index}>
      <div className="formLabel">{index + 1}. hodnota</div>
      <div className="formInput"><input type="text" ref={"parameterValue[" + index + "]"} name={index} value={item} onChange={this.handleArrayChange}/></div>
    </div>);

    const tree = Helpers.createCategoryTree(this.state.categoriesList);

    const categories = tree.map((item, index) => <div className="row" key={index}>
      <div className="col100">
        <p>
          <input type="checkbox" ref="category1" className="checkbox" name="category1" value={item._id} checked={this.state.categories.includes(item._id)} onChange={this.handleCategoryChange}/>{item.name}{
            typeof item.subcategory === "undefined"
              ? ""
              : item.subcategory.map((item2, index2) => <label key={index2}><input type="checkbox" ref="category1" className="checkbox" name="category1" value={item2._id} checked={this.state.categories.includes(item2._id)} onChange={this.handleCategoryChange}/>{item2.name}</label>)
          }
        </p>
      </div>
    </div>);

    return (<div className="form">
      <div ref="addProduct">
        <h1>
          {
            this.state.isUpdating
              ? "Upravit "
              : "Přidat "
          }produkt:
        </h1>

        <div className="formErrorMessages">
          {formErrorMessages}
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="col100">
              <div className="formLabel">Název produktu</div>
              <div className="formInput"><input type="text" name="name" ref="name" value={this.state.name} onChange={this.handleChange} required="required"/></div>
            </div>
            <div className="col100">
              <div className="formLabel">Popis produktu</div>
              <div className="formTextarea">
                <Editor editorState={this.state.editorState} wrapperClassName="description-wrapper" editorClassName="description-editor" onEditorStateChange={this.onEditorStateChange} toolbar={{
                    options: [
                      'inline',
                      'blockType',
                      'fontSize',
                      'list',
                      'textAlign',
                      'remove',
                      'history'
                    ],
                    inline: {
                      inDropdown: false,
                      className: undefined,
                      component: undefined,
                      dropdownClassName: undefined,
                      options: ['bold', 'italic', 'underline', 'strikethrough']
                    },
                    list: {
                      options: ['unordered', 'ordered']
                    }
                  }}/>
              </div>
            </div>
            <div className="col50">
              <div className="formLabel">Sleva %</div>
              <div className="formInput"><input type="text" ref="discount" value={this.state.discount} onChange={this.handleChange} name="discount"/></div>
            </div>
            <div className="col50">
              <div className="formLabel">Cena</div>
              <div className="formInput"><input type="text" ref="price" name="price" value={this.state.price} onChange={this.handleChange} required="required"/></div>
            </div>
            {
              this.state.isUpdating
                ? ""
                : <div>
                    <div className="col100">
                      <div className="formLabel">Hlavní obrázek:</div>
                      <div className="formInput"><input ref="mainImage" className="fileForm" type="file" onChange={this.handleImage} name="image"/></div>
                    </div>
                    <div className="col100">
                      <div className="formLabel">Další obrázky (možno vybrat více, npř. klávesou ctrl/cmd):</div>
                      <div className="formInput"><input ref="images" className="fileForm" type="file" onChange={this.handleImage} name="image" multiple="multiple"/></div>
                    </div>
                  </div>
            }

          </div>
        </form>

        <h2>Přidat parametr:</h2>
        <div>
          {parametersList}
        </div>

        <form onSubmit={this.handleSubmitParameter}>
          <div className="row">
            <div className="col50">
              <div className="formLabel">Název parametru</div>
              <div className="formInput"><input type="text" ref="parameterName" name="parameterName" value={this.state.parameterName} onChange={this.handleChange}/></div>
            </div>
            <div className="col50">
              {parameterValuess}
              <div className="formInput">
                <button className="addParameter" type="button" onClick={this.addParameterValueForm}>+</button>
              </div>
            </div>
            <div className="col100">
              <button type="submit">Přidat parametr</button>
            </div>
          </div>
        </form>

        <h2 ref="categories">Přidat do kategorie:</h2>
        <div className="categoryTree">
          {categories}
        </div>
        <div className="col100">
          <button type="submit" onClick={this.handleSubmit}>{
              this.state.isUpdating
                ? "Uložit změny"
                : "Přidat produkt"
            }</button>
        </div>
      </div>
    </div>);
  }
}
function mapStateToProps(state){
  return {
    admin: state.admin,
    menuPosition: state.menuPosition,
  };
}
export default connect(mapStateToProps)(AddProduct);



// WEBPACK FOOTER //
// ./src/pages/AddProduct.js